<template lang="pug">
	.section.section--white
		.donation-error
			VueFeedback(type="error")
				template(slot="feedback-title") Sikertelen tranzakció!
				template(slot="feedback-content")
					p.sf-text(v-if="transactionId") SimplePay tranzakció azonosító:
						strong  {{transactionId}}
					p.sf-text Kérjük, ellenőrizze a tranzakció során megadott adatok helyességét. Ha minden adatot helyesen adott meg, a visszautasítás okának kivizsgálása érdekében kérjük, szíveskedjen kapcsolatba lépni kártyakibocsátó bankjával.
</template>
<script>
import VueFeedback from '@ui-common/vue-feedback';
export default {
	props: {
		transactionId: {
			required: false
		}
	},

	components: {
		VueFeedback
	},
	mounted() {
		this.$scrollTo(this.$el);
	}
};
</script>
